<!-- Concat.vue -->
<template>
	<div class="main-content" v-if="detailInfo && detailInfo.if_chain">
	<flex-line :is-link="true" :show-border="true" @click.native="$router.push({name:'HomeChainList',query:{goods_id:detailInfo.goods_id}})">
		<span>自提门店</span>
	</flex-line>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import flexLine from '../../../flexLine'
export default {
  data () {
    return {
    }
  },
components:{flexLine},

  computed: {
    ...mapState({
      detailInfo: state => state.goodsdetail.detailInfo
    })
  },

  watch: {},

  created () {

  },

  methods: {

  }
}
</script>

<style lang="scss" scoped>
	.main-content{padding:0 $pageSpace;background-color: #fff;}
	.ui-promotions-wrapper {
		height: auto;
		&.ui-detail-common {
			padding: 0;
		}
		.promotions-header {
			padding: 0 $pageSpace;
			margin-top: 0.4rem;
			height: 2rem;
			line-height: 2rem;
			background:#fff;
			h3 {
				font-size:$subFontSize;
				color: #333;
				.iconfont{float:right;}
			}
			img {
				width:0.25rem;
				height: 0.5rem;
			}
		}

	}

</style>
